// ACTA_AGENT_ACTION_CONTRACT_V2

export const AGENT_RISK = {
  IMMEDIATE: "immediate",
  CONFIRM: "confirm",
  WORKFLOW: "workflow",
  CRITICAL: "critical",
};

export const AGENT_ACTION_STATUS = {
  IMPLEMENTED: "implemented",
  CATALOGUED: "catalogued",
  EXCLUDED: "excluded",
};

const VALID_RISKS =
  new Set(
    Object.values(
      AGENT_RISK
    )
  );

export function defineAgentAction(
  raw
) {
  if (
    !raw
    || typeof raw.id !== "string"
    || !raw.id.trim()
  ) {
    throw new Error(
      "Une action Agent doit avoir un id."
    );
  }

  if (
    !raw.label
    || typeof raw.label !== "string"
  ) {
    throw new Error(
      `Action ${raw.id}: label manquant.`
    );
  }

  const risk =
    raw.risk
    || AGENT_RISK.CONFIRM;

  if (!VALID_RISKS.has(risk)) {
    throw new Error(
      `Action ${raw.id}: risque invalide.`
    );
  }

  return Object.freeze({
    kind: "workflow",
    aliases: [],
    features: [],
    access: [],
    roles: [],
    requiredEntities: [],
    confirmation:
      risk === AGENT_RISK.IMMEDIATE
        ? false
        : risk === AGENT_RISK.CRITICAL
          ? "strong"
          : true,
    ...raw,
    id: raw.id.trim(),
    risk,
  });
}

export function validateAgentPlanShape(
  plan
) {
  if (
    !plan
    || !Array.isArray(
      plan.actions
    )
  ) {
    return {
      valid: false,
      error:
        "Le plan Agent doit contenir une liste d’actions.",
    };
  }

  if (
    plan.actions.length < 1
    || plan.actions.length > 10
  ) {
    return {
      valid: false,
      error:
        "Un plan Agent doit contenir entre 1 et 10 actions.",
    };
  }

  const invalid =
    plan.actions.find(
      (step) =>
        !step
        || typeof step.id !==
          "string"
        || !step.id.trim()
    );

  if (invalid) {
    return {
      valid: false,
      error:
        "Une étape du plan Agent est invalide.",
    };
  }

  return {
    valid: true,
    error: "",
  };
}
